import i18n from '@/plugins/vue-i18n'

export default {
  state: {
    locale: navigator.language.slice(0, 2) === 'fr' || navigator.language.slice(0, 2) === 'en' ? navigator.language.slice(0, 2) : 'en'
  },
  mutations: {
    setLocale (state, payload) {
      state.locale = payload
    }
  },
  actions: {
    setLocale ({ commit }, payload) {
      i18n.locale = payload
      commit('setLocale', payload)
    }
  },
  getters: {
    getLocale (state) {
      return state.locale
    }
  }
}
